import { keyframes } from 'styled-components';

export const slideCenterLeft = keyframes`
	0% {
		transform: translate3d(100%, 0, 0);
	}
	40% {
		transform: translate3d(0, 0, 0);
	}
	60% {
		transform: translate3d(0, 0, 0);
	}
	100% {
		transform: translate3d(-100%, 0, 0);
	}
`;

export const slideCenterRight = keyframes`
	0% {
		transform: translate3d(-100%, 0, 0);
	}
	40% {
		transform: translate3d(0, 0, 0);
	}
	60% {
		transform: translate3d(0, 0, 0);
	}
	100% {
		transform: translate3d(100%, 0, 0);
	}
`;
